import { createFileRoute } from "@tanstack/react-router";

import { AdminStyleImportsScreen } from "@/features/admin/screens/AdminStyleImports";

export const Route = createFileRoute(
  "/_authenticated/(admin)/admin/style-imports",
)({
  component: AdminStyleImportsScreen,
});
